export const emailIpWarmingAppGroupIdIpCount = "/email/ip_warming/:app_group_id/ip_count";
